// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oh-0";
export var discountCodeInput = "_oh-1";